import { render, staticRenderFns } from "./TaxLayout.vue?vue&type=template&id=00bc3375&scoped=true&"
import script from "./TaxLayout.vue?vue&type=script&lang=js&"
export * from "./TaxLayout.vue?vue&type=script&lang=js&"
import style0 from "./TaxLayout.vue?vue&type=style&index=0&id=00bc3375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc3375",
  null
  
)

export default component.exports